/**
 * DesktopDayHeader
 *
 * Column header for the desktop 7-column magazine grid.
 * Day name (uppercase, letter-spaced) + decorative date number.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika, PaprikaTypography, PaprikaSpacing } from '../../styles/theme';

interface DesktopDayHeaderProps {
  dayName: string;
  dayNumber: number;
  isToday: boolean;
}

export const DesktopDayHeader: React.FC<DesktopDayHeaderProps> = ({
  dayName,
  dayNumber,
  isToday,
}) => {
  return (
    <View style={styles.container}>
      <Text style={[styles.dayName, isToday && styles.dayNameToday]}>
        {dayName.toUpperCase()}
      </Text>
      <Text style={[styles.dayNumber, isToday && styles.dayNumberToday]}>
        {dayNumber}
      </Text>
      {isToday && <View style={styles.todayUnderline} />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingVertical: PaprikaSpacing.sm,
    marginBottom: PaprikaSpacing.sm,
  },
  dayName: {
    ...PaprikaTypography.labelLarge,
    color: Paprika.textSecondary,
    letterSpacing: 1.5,
  },
  dayNameToday: {
    color: Paprika.accent,
  },
  dayNumber: {
    ...PaprikaTypography.displayMedium,
    color: Paprika.textPrimary,
    opacity: 0.65,
    marginTop: -4,
  },
  dayNumberToday: {
    color: Paprika.accent,
    opacity: 1,
  },
  todayUnderline: {
    width: 24,
    height: 2,
    backgroundColor: Paprika.accent,
    borderRadius: 1,
    marginTop: -2,
  },
});

export default DesktopDayHeader;
